"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _orderEntryFormConstants = require("../../../constants/sendOrder/orderEntryFormConstants");
var _sidePanesConstants = require("../../../constants/sidePanesConstants");
var _sidePaneActions = require("../../../redux/actions/sidePaneActions");
var _selectors = require("../../../redux/margin/selectors");
var _kycLevelsSelectors = require("../../../redux/selectors/kycLevelsSelectors");
var _userSelectors = require("../../../redux/selectors/userSelectors");
var _OrderEntryAnchoring = _interopRequireDefault(require("./OrderEntryAnchoring"));
var _orderEntryActions = require("../../../redux/actions/orderEntryActions");
var _orderFormTypes = require("../../../constants/sendOrder/orderFormTypes");
var _orderEntrySelector = require("../../../redux/selectors/orderEntrySelector");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ORDER_FORM_NAME = 'orderEntry';
var OrderEntryComponentForm = (0, _reduxForm.reduxForm)({
  form: ORDER_FORM_NAME,
  enableReinitialize: false,
  destroyOnUnmount: false,
  onSubmit: function onSubmit(payload, dispatch) {
    dispatch((0, _orderEntryActions.placeOrderWithChecks)(_orderFormTypes.orderFormTypes["default"], payload));
  }
})(_OrderEntryAnchoring["default"]);
var selectorArgs = {
  formName: ORDER_FORM_NAME
};
var initialValues = {
  side: _orderEntryFormConstants.buyValue,
  orderType: _orderEntryFormConstants.orderTypes.limit.displayName,
  quantity: '',
  value: '',
  limitPrice: '',
  stopPrice: '',
  fee: '0',
  totalAmount: '0',
  timeInForce: '1',
  anchoredField: ''
};
var mapStateToProps = function mapStateToProps(state) {
  var side = (0, _orderEntrySelector.selectOrderSide)(state, selectorArgs);
  return {
    allowBlockTrading: (0, _userSelectors.isBlockTradingEnabledForUser)(state),
    initialValues: initialValues,
    disableTrading: (0, _kycLevelsSelectors.kycVerificationLevelsSelector)(state).disableTrading,
    isMarginActive: (0, _selectors.isMarginActiveSelector)(state),
    maxQuantity: (0, _orderEntrySelector.selectOrderMaxQuantity)(state, selectorArgs),
    isBuy: side === _orderEntryFormConstants.buyValue,
    side: side,
    hasCredit: (0, _orderEntrySelector.hasCreditTierSelector)(state)
  };
};
var mapDispatchToProps = {
  reduxFormChange: function reduxFormChange(key, val) {
    return (0, _reduxForm.change)(ORDER_FORM_NAME, key, val);
  },
  openAdvancedOrderSidePane: function openAdvancedOrderSidePane() {
    return (0, _sidePaneActions.openSidePane)(_sidePanesConstants.SIDE_PANES.ADVANCED_ORDER);
  },
  openReportBlockTradeSidePane: function openReportBlockTradeSidePane() {
    return (0, _sidePaneActions.openSidePane)(_sidePanesConstants.SIDE_PANES.REPORT_BLOCK_TRADE);
  }
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(OrderEntryComponentForm);